import script from "./NavDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./NavDrawer.vue?vue&type=script&setup=true&lang=js"

import "./NavDrawer.vue?vue&type=style&index=0&id=8916017e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8916017e"]])

export default __exports__